// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Traders Section Card ========== */
.traders-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.traders-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.traders-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.traders-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.traders-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.traders-section__stats {
  display: flex;
  gap: 1.25rem;
}

.traders-filters {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.traders-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.traders-filter-search {
  flex: 1 1;
  min-width: 200px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.traders-filter-search:focus {
  outline: none;
  border-color: #0f766e;
}

.traders-filter-select {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-width: 120px;
  background: #fff;
}

.traders-filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.traders-filter-btn:hover {
  opacity: 0.95;
}

.traders-error {
  padding: 0.85rem 1.5rem;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #fecaca;
}

.traders-loading,
.traders-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.traders-loading i {
  margin-right: 0.5rem;
}

.traders-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.traders-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.traders-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.traders-pagination__btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #0f766e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.traders-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
}

.traders-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.traders-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.traders-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

/* ========== Table ========== */
.traders-list-content {
  padding: 0;
}

.traders-table-wrap {
  overflow-x: auto;
}

.traders-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.traders-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.traders-table th {
  padding: 1rem 1.25rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.traders-table td {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.traders-table tbody tr {
  transition: background 0.15s;
}

.traders-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.traders-table tbody tr:hover {
  background: #f0fdfa !important;
}

.traders-table tbody tr:last-child td {
  border-bottom: none;
}

.traders-table__actions {
  white-space: nowrap;
}

.traders-table__actions .btn-icon {
  margin: 0 3px;
}

/* UUID – clickable pill */
.traders-table__uuid-link {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, transform 0.15s;
}

.traders-table__uuid-link:hover {
  background: #0ea5e9;
  color: #fff;
  transform: translateY(-1px);
}

.traders-status-select {
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid;
  cursor: pointer;
  font-family: inherit;
}

.traders-status-select--active {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.traders-status-select--inactive {
  background: #fee2e2;
  color: #b91c1c;
  border-color: #fca5a5;
}

.traders-status-select:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ========== Action Buttons ========== */
.btn-icon {
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.85rem;
  transition: transform 0.15s, box-shadow 0.15s;
}

.btn-icon:hover {
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.btn-icon--view {
  background: #dbeafe;
  color: #0f766e;
}

.btn-icon--view:hover {
  background: #93c5fd;
  color: #fff;
}

.btn-icon--edit {
  background: #fef3c7;
  color: #b45309;
}

.btn-icon--edit:hover {
  background: #fcd34d;
  color: #92400e;
}

.btn-icon--block {
  background: #fee2e2;
  color: #b91c1c;
}

.btn-icon--block:hover {
  background: #f87171;
  color: #fff;
}

.btn-icon--unblock {
  background: #dcfce7;
  color: #15803d;
}

.btn-icon--unblock:hover {
  background: #22c55e;
  color: #fff;
}

/* ========== Trader Detail Modal ========== */
.trader-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: traderModalFade 0.2s ease;
}

@keyframes traderModalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.trader-detail-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 420px;
  overflow: hidden;
  animation: traderModalSlide 0.3s ease;
}

@keyframes traderModalSlide {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.trader-detail-modal__head {
  position: relative;
  padding: 2rem 1.5rem 1.5rem;
  background: linear-gradient(160deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.trader-detail-modal__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 1rem;
  border: 3px solid rgba(255, 255, 255, 0.4);
}

.trader-detail-modal__head-text {
  margin: 0;
}

.trader-detail-modal__name {
  margin: 0 0 0.25rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
}

.trader-detail-modal__email {
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.trader-detail-modal__status {
  display: inline-block;
  padding: 0.25rem 0.65rem;
  font-size: 0.75rem;
  border-radius: 20px;
  font-weight: 600;
}

.trader-detail-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.trader-detail-modal__close:hover {
  background: rgba(255, 255, 255, 0.35);
}

.trader-detail-modal__body {
  padding: 1.5rem;
}

.trader-detail-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.trader-detail-list__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  background: #f8fafc;
  border-radius: 10px;
  font-size: 0.9rem;
  color: var(--text);
}

.trader-detail-list__item i {
  width: 20px;
  color: #0f766e;
  font-size: 0.85rem;
}

.trader-detail-list__uuid {
  font-family: ui-monospace, monospace;
  font-size: 0.85rem;
  color: #475569;
}

.trader-detail-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.trader-detail-modal__footer .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  border-radius: 10px;
  cursor: pointer;
  min-width: 100px;
  justify-content: center;
}

.btn-ghost {
  background: #f1f5f9;
  color: var(--text);
  border: none;
}

.btn-ghost:hover {
  background: #e2e8f0;
}

.trader-detail-modal__footer .btn-primary {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
}

.trader-detail-modal__footer .btn-primary:hover {
  opacity: 0.95;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.35);
}

/* ========== Tabbed modal ========== */
.trader-detail-modal--tabs {
  max-width: 560px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.trader-detail-modal__tabs {
  display: flex;
  gap: 0;
  padding: 0 1rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
}

.trader-detail-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  margin-bottom: -1px;
  transition: color 0.2s, border-color 0.2s;
}

.trader-detail-tab i {
  font-size: 0.9rem;
}

.trader-detail-tab:hover {
  color: var(--text);
}

.trader-detail-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.trader-detail-modal__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem 1.5rem;
}

.trader-detail-pane {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.trader-detail-block {
  background: #f8fafc;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  border: 1px solid #e2e8f0;
}

.trader-detail-block__title {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.trader-detail-dl {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.5rem;
}

.trader-detail-dl div {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
}

.trader-detail-dl dt {
  margin: 0;
  min-width: 100px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
}

.trader-detail-dl dd {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text);
}

.trader-detail-uuid {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #475569;
}

.trader-detail-kyc {
  margin: 0;
}

.badge--kyc-0 { background: #fef3c7; color: #92400e; }
.badge--kyc-1 { background: #fef3c7; color: #92400e; }
.badge--kyc-2, .badge--kyc-3 { background: #dcfce7; color: #166534; }

/* Trading stats */
.trader-detail-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.trader-detail-stat {
  text-align: center;
  padding: 0.75rem;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.trader-detail-stat__v {
  display: block;
  font-size: 1rem;
  font-weight: 700;
  color: #0f766e;
  margin-bottom: 0.2rem;
}

.trader-detail-stat__l {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-transform: uppercase;
}

/* Mini tables inside modal */
.trader-detail-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.trader-detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.trader-detail-table th {
  padding: 0.6rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-muted);
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.trader-detail-table td {
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
}

.trader-detail-table tbody tr:last-child td {
  border-bottom: none;
}

.text-buy { color: #16a34a; font-weight: 500; }
.text-sell { color: #dc2626; font-weight: 500; }

/* Activity list */
.trader-detail-activity {
  margin: 0;
  padding: 0;
  list-style: none;
}

.trader-detail-activity__item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.85rem;
}

.trader-detail-activity__item:last-child {
  border-bottom: none;
}

.trader-detail-activity__action {
  font-weight: 600;
  color: var(--text);
  min-width: 60px;
}

.trader-detail-activity__detail {
  color: var(--text-muted);
}

.trader-detail-activity__meta {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.trader-detail-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  background: #fff;
}

.trader-detail-modal__footer .btn {
  min-width: 100px;
}

/* Edit modal – keep existing in page */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal {
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text);
}

.modal-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  color: var(--text-muted);
  font-size: 1.1rem;
  cursor: pointer;
}

.modal-close:hover {
  background: var(--main-bg);
  color: var(--text);
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
}

.modal-field {
  margin-bottom: 1rem;
}

.modal-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text);
}

.modal-field input,
.modal-field select {
  width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text);
}

.modal-field input:focus,
.modal-field select:focus {
  outline: none;
  border-color: #14b8a6;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.modal-footer .btn {
  min-width: 90px;
}

.traders-list-content .btn-primary {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
}

.traders-list-content .btn-secondary {
  background: var(--main-bg);
  color: var(--text);
  border: 1px solid var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Traders/TradersListPage.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,aAAa,cAAc,EAAE,gBAAgB,EAAE;;AAE/C,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;AACjC","sourcesContent":["/* ========== Traders Section Card ========== */\n.traders-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.traders-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.traders-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.traders-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.traders-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.traders-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.traders-filters {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.traders-filters__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.traders-filter-search {\n  flex: 1;\n  min-width: 200px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.traders-filter-search:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.traders-filter-select {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  min-width: 120px;\n  background: #fff;\n}\n\n.traders-filter-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.traders-filter-btn:hover {\n  opacity: 0.95;\n}\n\n.traders-error {\n  padding: 0.85rem 1.5rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-bottom: 1px solid #fecaca;\n}\n\n.traders-loading,\n.traders-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n}\n\n.traders-loading i {\n  margin-right: 0.5rem;\n}\n\n.traders-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.traders-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.traders-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.traders-pagination__btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #0f766e;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.traders-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n}\n\n.traders-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.traders-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.traders-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n/* ========== Table ========== */\n.traders-list-content {\n  padding: 0;\n}\n\n.traders-table-wrap {\n  overflow-x: auto;\n}\n\n.traders-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.traders-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.traders-table th {\n  padding: 1rem 1.25rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.traders-table td {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.traders-table tbody tr {\n  transition: background 0.15s;\n}\n\n.traders-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.traders-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.traders-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.traders-table__actions {\n  white-space: nowrap;\n}\n\n.traders-table__actions .btn-icon {\n  margin: 0 3px;\n}\n\n/* UUID – clickable pill */\n.traders-table__uuid-link {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  background: #e0f2fe;\n  color: #0369a1;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s, transform 0.15s;\n}\n\n.traders-table__uuid-link:hover {\n  background: #0ea5e9;\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.traders-status-select {\n  padding: 0.3rem 0.6rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.traders-status-select--active {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #86efac;\n}\n\n.traders-status-select--inactive {\n  background: #fee2e2;\n  color: #b91c1c;\n  border-color: #fca5a5;\n}\n\n.traders-status-select:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ========== Action Buttons ========== */\n.btn-icon {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: none;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.btn-icon:hover {\n  transform: scale(1.08);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.btn-icon--view {\n  background: #dbeafe;\n  color: #0f766e;\n}\n\n.btn-icon--view:hover {\n  background: #93c5fd;\n  color: #fff;\n}\n\n.btn-icon--edit {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.btn-icon--edit:hover {\n  background: #fcd34d;\n  color: #92400e;\n}\n\n.btn-icon--block {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.btn-icon--block:hover {\n  background: #f87171;\n  color: #fff;\n}\n\n.btn-icon--unblock {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.btn-icon--unblock:hover {\n  background: #22c55e;\n  color: #fff;\n}\n\n/* ========== Trader Detail Modal ========== */\n.trader-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  animation: traderModalFade 0.2s ease;\n}\n\n@keyframes traderModalFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.trader-detail-modal {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);\n  width: 100%;\n  max-width: 420px;\n  overflow: hidden;\n  animation: traderModalSlide 0.3s ease;\n}\n\n@keyframes traderModalSlide {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.trader-detail-modal__head {\n  position: relative;\n  padding: 2rem 1.5rem 1.5rem;\n  background: linear-gradient(160deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.trader-detail-modal__avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.35rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  border: 3px solid rgba(255, 255, 255, 0.4);\n}\n\n.trader-detail-modal__head-text {\n  margin: 0;\n}\n\n.trader-detail-modal__name {\n  margin: 0 0 0.25rem;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.trader-detail-modal__email {\n  margin: 0 0 0.5rem;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.trader-detail-modal__status {\n  display: inline-block;\n  padding: 0.25rem 0.65rem;\n  font-size: 0.75rem;\n  border-radius: 20px;\n  font-weight: 600;\n}\n\n.trader-detail-modal__close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.trader-detail-modal__close:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.trader-detail-modal__body {\n  padding: 1.5rem;\n}\n\n.trader-detail-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.trader-detail-list__item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.65rem 1rem;\n  background: #f8fafc;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.trader-detail-list__item i {\n  width: 20px;\n  color: #0f766e;\n  font-size: 0.85rem;\n}\n\n.trader-detail-list__uuid {\n  font-family: ui-monospace, monospace;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.trader-detail-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.trader-detail-modal__footer .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: 10px;\n  cursor: pointer;\n  min-width: 100px;\n  justify-content: center;\n}\n\n.btn-ghost {\n  background: #f1f5f9;\n  color: var(--text);\n  border: none;\n}\n\n.btn-ghost:hover {\n  background: #e2e8f0;\n}\n\n.trader-detail-modal__footer .btn-primary {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n}\n\n.trader-detail-modal__footer .btn-primary:hover {\n  opacity: 0.95;\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.35);\n}\n\n/* ========== Tabbed modal ========== */\n.trader-detail-modal--tabs {\n  max-width: 560px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.trader-detail-modal__tabs {\n  display: flex;\n  gap: 0;\n  padding: 0 1rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n  overflow-x: auto;\n}\n\n.trader-detail-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  margin-bottom: -1px;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.trader-detail-tab i {\n  font-size: 0.9rem;\n}\n\n.trader-detail-tab:hover {\n  color: var(--text);\n}\n\n.trader-detail-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.trader-detail-modal__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem 1.5rem;\n}\n\n.trader-detail-pane {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.trader-detail-block {\n  background: #f8fafc;\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n  border: 1px solid #e2e8f0;\n}\n\n.trader-detail-block__title {\n  margin: 0 0 0.75rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.trader-detail-dl {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.5rem;\n}\n\n.trader-detail-dl div {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n}\n\n.trader-detail-dl dt {\n  margin: 0;\n  min-width: 100px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.trader-detail-dl dd {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text);\n}\n\n.trader-detail-uuid {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #475569;\n}\n\n.trader-detail-kyc {\n  margin: 0;\n}\n\n.badge--kyc-0 { background: #fef3c7; color: #92400e; }\n.badge--kyc-1 { background: #fef3c7; color: #92400e; }\n.badge--kyc-2, .badge--kyc-3 { background: #dcfce7; color: #166534; }\n\n/* Trading stats */\n.trader-detail-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n.trader-detail-stat {\n  text-align: center;\n  padding: 0.75rem;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.trader-detail-stat__v {\n  display: block;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f766e;\n  margin-bottom: 0.2rem;\n}\n\n.trader-detail-stat__l {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n}\n\n/* Mini tables inside modal */\n.trader-detail-table-wrap {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.trader-detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.trader-detail-table th {\n  padding: 0.6rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.trader-detail-table td {\n  padding: 0.6rem 0.75rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.trader-detail-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.text-buy { color: #16a34a; font-weight: 500; }\n.text-sell { color: #dc2626; font-weight: 500; }\n\n/* Activity list */\n.trader-detail-activity {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.trader-detail-activity__item {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 0.85rem;\n}\n\n.trader-detail-activity__item:last-child {\n  border-bottom: none;\n}\n\n.trader-detail-activity__action {\n  font-weight: 600;\n  color: var(--text);\n  min-width: 60px;\n}\n\n.trader-detail-activity__detail {\n  color: var(--text-muted);\n}\n\n.trader-detail-activity__meta {\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.trader-detail-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n  background: #fff;\n}\n\n.trader-detail-modal__footer .btn {\n  min-width: 100px;\n}\n\n/* Edit modal – keep existing in page */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.modal {\n  background: var(--card-bg);\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 440px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.modal-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  cursor: pointer;\n}\n\n.modal-close:hover {\n  background: var(--main-bg);\n  color: var(--text);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n.modal-field {\n  margin-bottom: 1rem;\n}\n\n.modal-field label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.modal-field input,\n.modal-field select {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  color: var(--text);\n}\n\n.modal-field input:focus,\n.modal-field select:focus {\n  outline: none;\n  border-color: #14b8a6;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.modal-footer .btn {\n  min-width: 90px;\n}\n\n.traders-list-content .btn-primary {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n}\n\n.traders-list-content .btn-secondary {\n  background: var(--main-bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
